import React, { Component } from "react";
import CategoryList from "../CategoryList";
import Category from "../Category";
import Section from "../Section";
import { Switch, Route, withRouter } from "react-router-dom";

export class App extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/knowledge/arrange" component={CategoryList} />
        <Route
          exact
          path="/knowledge/arrange/categories"
          component={CategoryList}
        />
        <Route
          exact
          path="/knowledge/arrange/categories/page/:page"
          component={CategoryList}
        />
        <Route
          exact
          path="/knowledge/arrange/categories/:id"
          component={Category}
        />
        <Route
          exact
          path="/knowledge/arrange/categories/:id/page/:page"
          component={Category}
        />
        <Route
          exact
          path="/knowledge/arrange/sections/:id"
          component={Section}
        />
        <Route
          exact
          path="/knowledge/arrange/sections/:id/section_page/:sectionPage/article_page/:articlePage"
          component={Section}
        />
      </Switch>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App/index.js